import { render, staticRenderFns } from "./NewsCenterView.vue?vue&type=template&id=2e19d2c8&scoped=true"
import script from "./NewsCenterView.vue?vue&type=script&lang=js"
export * from "./NewsCenterView.vue?vue&type=script&lang=js"
import style0 from "./NewsCenterView.vue?vue&type=style&index=0&id=2e19d2c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e19d2c8",
  null
  
)

export default component.exports